// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsAndConditions_container__Przmd {
  display: flex;
  align-items: flex-end;
  margin-top: 18px;
}

.TermsAndConditions_close__qTJaS {
  position: absolute;
  right: 10px;
  width: 25px;
  top: 10px;
}

.TermsAndConditions_popup-trigger__r\\+Unc {
  cursor: pointer;
  font-weight: bold;
  color: #0058e1;
}

.TermsAndConditions_react-pdf__Page__wFiZN {
  width: 100% !important;
  height: 100% !important;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/views/TermsAndConditions/TermsAndConditions.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AADF;;AAIA;EACE,eAAA;EACA,iBCVK;EDWL,cEIU;AFLZ;;AAIA;EACE,sBAAA;EACA,uBAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;AADF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.container {\n  display: flex;\n  align-items: flex-end;\n  margin-top: 18px;\n}\n\n.close {\n  position: absolute;\n  right: 10px;\n  width: 25px;\n  top: 10px;\n}\n\n.popup-trigger {\n  cursor: pointer;\n  font-weight: typography.$bold;\n  color: colors.$text-link;\n}\n\n.react-pdf__Page {\n  width: 100% !important;\n  height: 100% !important;\n}\n\ncanvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TermsAndConditions_container__Przmd`,
	"close": `TermsAndConditions_close__qTJaS`,
	"popup-trigger": `TermsAndConditions_popup-trigger__r+Unc`,
	"react-pdf__Page": `TermsAndConditions_react-pdf__Page__wFiZN`
};
export default ___CSS_LOADER_EXPORT___;
